export default __webpack_public_path__ + "static/media/Commander's Belt of the Ascending Kingdom.3f7db16c.jpg";